import React from 'react';
import { FilledIconContainer, IconContainer } from 'theming/tokens/components/icon';
const ExclamationOctagonIcon = props => {
  if (props.variant === 'filled') {
    return /*#__PURE__*/React.createElement(FilledIconContainer, {
      fill: props.fill,
      size: props.size
    }, /*#__PURE__*/React.createElement("path", {
      d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
    }));
  }
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("line", {
    x1: "128",
    y1: "136",
    x2: "128",
    y2: "80",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.45,32H91.55a8,8,0,0,0-5.66,2.34L34.34,85.89A8,8,0,0,0,32,91.55v72.9a8,8,0,0,0,2.34,5.66l51.55,51.55A8,8,0,0,0,91.55,224h72.9a8,8,0,0,0,5.66-2.34l51.55-51.55a8,8,0,0,0,2.34-5.66V91.55a8,8,0,0,0-2.34-5.66L170.11,34.34A8,8,0,0,0,164.45,32Z",
    fill: "none",
    stroke: "inherit",
    strokeMiterlimit: "10",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "128",
    cy: "172",
    r: "6",
    fill: "inherit"
  }));
};
export { ExclamationOctagonIcon };